import {Engagement} from '../../bookExpert/engagements'
import {Expert} from '../../bookExpert/expertDirectory'

// Pure helpers for the WP-X7 member expertise tab (framework-free, unit-testable).

// Normalize a paginated-or-array API payload to a plain array.
export const toArray = <T>(payload: any): T[] =>
  Array.isArray(payload) ? payload : payload?.results ?? []

// Find the member's own ExpertProfile in the admin expert-profiles list (member-experts only —
// the member detail is a final-user, so match on expertMember.id).
export const pickMemberExpertProfile = (payload: any, userId: number | string): Expert | null => {
  const list = toArray<any>(payload)
  const uid = Number(userId)
  return list.find((p) => p?.expertMember?.id === uid) ?? null
}

// Split a member's engagements by the side the member is on (client vs expert), for the tab's
// two groupings. The member is `userId`.
export const splitEngagementsByRole = (
  engagements: Engagement[],
  userId: number | string
): {asClient: Engagement[]; asExpert: Engagement[]} => {
  const uid = Number(userId)
  const asClient: Engagement[] = []
  const asExpert: Engagement[] = []
  for (const e of engagements) {
    if (e?.client?.id === uid) asClient.push(e)
    else asExpert.push(e)
  }
  return {asClient, asExpert}
}
